import { Publicprofile } from '@/payload-types'
import { ProfileCardComponent } from '@/components/public-profile-card/profileCard'

interface IProps {
  profileData: (string | null) | Publicprofile
}

export const FeaturedPostProfileCardComponent = ({ profileData }: IProps) => {
  if (profileData && typeof profileData === 'object' && profileData._status !== 'published') {
    return <></>
  }
  return (
    <div className={'mb-6 pb-8 divider'}>
      <ProfileCardComponent
        profileData={profileData}
        profilePicture={{
          pictureDivCSS: 'w-28 h-28',
          pictureCSS: 'rounded-full shadow-md default-border',
        }}
        profileFullName={{
          fullNameDivCSS: 'my-3',
          fullNameCSS: 'font-bold text-xl leading-[27px]',
        }}
        profileDescription={{
          ifShow: true,
          descriptionNode:
            profileData && typeof profileData === 'object' && 'meta' in profileData ? (
              <div className={'text-sm font-medium line-clamp-[15]'}>
                {profileData.meta.description}
              </div>
            ) : (
              <></>
            ),
        }}
        seeProfileBtn={{ ifShow: true, btnCSS: 'shadow-btn mt-3' }}
      />
    </div>
  )
}

export default FeaturedPostProfileCardComponent
